import { render, staticRenderFns } from "./ComponentContextMenu.vue?vue&type=template&id=2e2cfb7a"
import script from "./ComponentContextMenu.vue?vue&type=script&lang=js"
export * from "./ComponentContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports